import React, { Component } from "react";

import Layout from "../header_footer/Layout";

import Jumbotron from "../utils/Jumbotron";

import AlojamentoSmall from "../utils/EspacosSmall/EspacoSmall";

import PropTypes from 'prop-types';

import axios from "axios";

import Masonry from 'react-masonry-component';

class Alojamentos extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      alojamentos: []
    };
  }

  componentDidMount = () => {
    this.loadAlojamentos();
  };

  loadAlojamentos = async () => {
    /*
    let alojamentos = [
      {
        id: 1,
        nome: "Casa dos Gémeos",
        tipo: "Apartamento",
        mainPhoto: "/images/apagar_restaurantes_lojas/1.jpg"
      },
      {id: 2,
        nome: "Abrigo da Montanha",
        tipo: "Hotel",
        mainPhoto: "/images/apagar_restaurantes_lojas/2.jpg"
      },
      {
        id: 3,
        nome: "Abrigo da Montanha II",
        tipo: "Hotel",
        mainPhoto: "/images/apagar_restaurantes_lojas/3.jpg"
      },
      {
        id: 1,
        nome: "Miralva",
        tipo: "Pratos Tradicionais",
        mainPhoto: "/images/apagar_restaurantes_lojas/4.jpg"
      },
      {
        id: 1,
        nome: "O Abrigo da Montanha",
        tipo: "Pratos Tradicionais",
        mainPhoto: "/images/apagar_restaurantes_lojas/5.jpg"
      },
      {
        id: 1,
        nome: "A Estrelinha",
        tipo: "Pratos Tradicionais",
        mainPhoto: "/images/apagar_restaurantes_lojas/1.jpg"
      },
      {
        id: 1,
        nome: "Monte Estrela",
        tipo: "Pratos Tradicionais",
        mainPhoto: "/images/apagar_restaurantes_lojas/2.jpg"
      },
      {
        id: 1,
        nome: "Ribeira D'Alva",
        tipo: "Pratos Tradicionais",
        mainPhoto: "/images/apagar_restaurantes_lojas/3.jpg"
      },
      {
        id: 1,
        nome: "O Martins",
        tipo: "Pratos Tradicionais",
        mainPhoto: "/images/apagar_restaurantes_lojas/4.jpg"
      },
      {
        id: 1,
        nome: "Casa da Ponte",
        tipo: "Grelhados",
        mainPhoto: "/images/apagar_restaurantes_lojas/5.jpg"
      }
    ];
    */

   let res = {};
   try {
     res = await axios.get("/api/alojamentos", {
       params: {
       },
       headers: {
         APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf",
         "Content-Type": "application/json"
       }
     });
   } catch (error) {
     console.log(error);
   }

   let alojamentos = res.data.arrayAlojamentos;

    this.setState({ alojamentos });
  };

  alojamentoClicked = (identifier) => {
    this.context.router.history.push("/alojamentos/" + identifier);
  }

  render() {

    return (
      <Layout>
        <Jumbotron title={"Alojamento"}></Jumbotron>

        <div className="container">
          <Masonry
            className={"row"}
            elementType={"div"}
            options={{transitionDuration: 0}}
          >
              {
                this.state.alojamentos.map(function(item) {
                  return <AlojamentoSmall entityClicked={this.alojamentoClicked} item={item} key={item.name}></AlojamentoSmall>
                }.bind(this))
              }

           </Masonry>
        </div>


      </Layout>
    );
  }
}

export default Alojamentos;
